<template>
  <validation-observer v-if="dialogComputed" ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="dialogComputed" max-width="500px" scrollable persistent>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0016') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text class="px-0">
          <v-container>
            <v-row>
              <v-col>
                <TextFieldInput :label="$t('ELE0033')" v-model="title" :maxLength="60" required />
              </v-col>
            </v-row>
            <v-row class="pb-0">
              <v-col>
                <TextFieldInput
                  :label="$t('ELE0546')"
                  v-model="link"
                  :maxLength="2000"
                  rules="regex:^https?://"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
          <v-divider />
        </v-card-text>
        <v-card-actions class="d-flex align-end justify-end">
          <Btn :label="$t('ELE0105')" @click="onClickSet" :disabled="invalid" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'LinkAttachmentDialog',

  components: {
    ValidationObserver,
    TextFieldInput,
    Btn,
  },
  data() {
    return {
      title: null,
      link: null,
    }
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    close() {
      this.title = null
      this.link = null
      this.dialogComputed = false
    },
    onClickSet() {
      const linkDetail = {
        title: this.title,
        link: this.link,
      }
      this.$emit('set', linkDetail)
      this.close()
    },
  },
}
</script>
